module.exports = __webpack_public_path__ + "img/tech_image_1.ef8bc497.jpg";